var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lotti-app",class:_vm.isSigninRoute()},[_c('navigation'),_vm._v(" "),_c('div',{staticClass:"lotti-container"},[_c('div',{staticClass:"lotti-content"},[_c('router-view')],1)]),_vm._v(" "),_c('page-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }